/**
 * Shared Recharts styling tokens so every chart in the app reads as one family.
 *
 * Conventions (matching the design overhaul):
 *  - No CartesianGrid; use thin dashed ReferenceLines instead.
 *  - Muted neutral axes, no axis/tick lines.
 *  - Rounded bar tops.
 *  - Legend below the chart, small.
 *  - Dark tooltip surface in both light & dark mode (deliberate, for contrast).
 */
import { semantic, shadows, DARK } from "../../config/theme";

/** Axis tick style. Use `AXIS_TICK_SM` for dense/mobile axes. */
export const AXIS_TICK = { fill: semantic.neutral, fontSize: 12 } as const;
export const AXIS_TICK_SM = { fill: semantic.neutral, fontSize: 10 } as const;

/** Spread onto <XAxis>/<YAxis> to drop the axis + tick lines consistently. */
export const AXIS_PROPS = { axisLine: false, tickLine: false } as const;

/** Standard rounded bar top. */
export const BAR_RADIUS: [number, number, number, number] = [4, 4, 0, 0];

/** Thin dashed reference line (zero line, averages, thresholds). */
export const REFERENCE_LINE = { stroke: semantic.neutral, strokeDasharray: "4 4" } as const;

/** Warning-colored reference line (e.g. average markers). */
export const REFERENCE_LINE_WARN = { stroke: semantic.warning, strokeDasharray: "4 4" } as const;

/** <Legend wrapperStyle> value. */
export const LEGEND_STYLE = { paddingTop: 12, fontSize: 12 } as const;

/** Dark tooltip surface — applied to the custom tooltip Box. */
export const CHART_TOOLTIP_SX = {
  bgcolor: DARK.surface,
  color: "#fff",
  borderRadius: 1.5,
  p: 1.5,
  boxShadow: shadows.dropdown,
  fontSize: 12,
  minWidth: 120,
} as const;

/** Background passed to html-to-image exports of charts. */
export const CHART_EXPORT_BG = DARK.surface;
